import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptTypeViewStore } from "../../store";
import { PaymentReceiptTypeViewForm } from "./PaymentReceiptTypeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PaymentReceiptTypeViewProps = {
  paymentReceiptTypeViewStore: PaymentReceiptTypeViewStore;
};

export const PaymentReceiptTypeView: React.FC<PaymentReceiptTypeViewProps> =
  observer(({ paymentReceiptTypeViewStore }) => {
    return (
      <div>
        <PaymentReceiptTypeViewForm
          name_es={paymentReceiptTypeViewStore.name_esValue}
          name_en={paymentReceiptTypeViewStore.name_enValue}
          name_pt={paymentReceiptTypeViewStore.name_ptValue}
          price={paymentReceiptTypeViewStore.priceValue}
          currencyValue={paymentReceiptTypeViewStore.currencyValue}
          onPrint={(handlePrint: () => void) =>
            paymentReceiptTypeViewStore.printPaymentReceiptType(handlePrint)
          }
          onCancel={() =>
            paymentReceiptTypeViewStore.cancelPaymentReceiptType()
          }
          onEdit={
            paymentReceiptTypeViewStore.isEditEnabled
              ? () => paymentReceiptTypeViewStore.editPaymentReceiptType()
              : undefined
          }
        />
        <ErrorDialog
          open={paymentReceiptTypeViewStore.errorDialogOpened}
          title={paymentReceiptTypeViewStore.errorTitle}
          description={paymentReceiptTypeViewStore.errorDescription}
          onClose={() => paymentReceiptTypeViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
